import { gql } from "@apollo/client"

const DELETE_SESSION_MUTATION = gql`
  mutation($input: DeleteSessionInput!) {
    deleteSession(input: $input) {
      id
    }
  }
`

export { DELETE_SESSION_MUTATION }